import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubscriptionsByClientID } from '@redux/features/subscriptionsSlice';
import { SubscriptionManager } from 'pages/Database/Clients/ClientPage/Subscription/SubscriptionManager';

export const SubscriptionsTab = ({ entity, entityType }) => {
  const dispatch = useDispatch();
  const { subscriptions, isLoading } = useSelector((state) => state.subscriptions);

  useEffect(() => {
    if (entityType === 'client' && entity?.id) {
      dispatch(getSubscriptionsByClientID(entity.id));
    }
  }, [dispatch, entity?.id, entityType]);

  return (
    <div>
      <SubscriptionManager clientID={entity.id} subscriptions={subscriptions} isLoading={isLoading} />
    </div>
  );
};
